import connectToStores from "alt-utils/lib/connectToStores";
import { Checks, RecommendedJobs, Onboarding, SimpleCard, Button } from "components";
import {
  SeoToolsContainer,
  SearchConsoleContainer,
  ManageInstallContainer
} from "containers";
import {
  CheckActions,
  NotFoundCheckDetailActions,
  OnboardingActions
} from "actions";
import { CheckStore, NotFoundCheckDetailStore, OnboardingStore } from "stores";
import { Analytics } from "common-frontend";
import { ChargeUtils } from 'utils'
import Helmet from "react-helmet";
import { API_BASE, UI_MIGRATION_PATH } from 'consts'

import "./checksContainer.scss";

@connectToStores
export default class ChecksContainer extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object
  };

  componentWillMount() {
    CheckActions.fetchAndRefresh(this.context.currentUser.activeCharge);

    OnboardingActions.determineIfUserShouldSelectPlan(this.context.currentUser.accessToken);
  }

  static getStores() {
    return [CheckStore, NotFoundCheckDetailStore, OnboardingStore];
  }

  static getPropsFromStores() {
    return {
      ...CheckStore.getState(),
      ...NotFoundCheckDetailStore.getState(),
      ...OnboardingStore.getState()
    };
  }

  hideUIMigration() {
    const row = document.getElementById("dashboard__rowUIMigration")
    const path = document.location.pathname
    // expire in 7 days
    const maxAge = 7 * 24 * 60 * 60
    row.classList.add("dashboard__hidden")
    document.cookie = "uiMigrationRow=hidden; SameSite=Strict; max-age="+maxAge+"; path="+path+";"
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  render() {
    const { activeCharge, trialDaysLeft, trialEndsDateCaption } = this.context.currentUser;
    const searchTrendsTitle = (
      <span>
        <span>Search Trends</span>
        <span className="dashboard__searchTrends__plus-tag">Plus</span>
      </span>
    );

    const urlParams = new URLSearchParams(window.location.search);
    const newUI = urlParams.get('new_ui') == 'on' && this.getCookie("uiMigrationRow") != "hidden";


    if (this.context.currentUser.shouldSelectPlan) {
      return <div className={`dashboard ${activeCharge ? "plus" : ""}`}>
        <Helmet title="Plug in SEO" />
        <div className="dashboard__row">
          <div className="dashboard__trialNotice">
            Loading...
          </div>
        </div>
      </div>
    }

    return (
      <div className={`dashboard ${activeCharge ? "plus" : ""}`}>
        <Helmet title="Plug in SEO - Checks" />
        {activeCharge && (
          <div className="dashboard__row">
            <ManageInstallContainer location={this.props.location} />
          </div>
        )}
        {activeCharge && trialDaysLeft && trialDaysLeft > 0 &&
          <div className="dashboard__row">
            <div className="dashboard__trialNotice">
              You are currently on a free trial and will not be charged until {trialEndsDateCaption}.
              If you’d like to downgrade to a free account you can do so <strong><a href={API_BASE + '/v3ui/pricing'}>here</a></strong>.
            </div>
          </div>
        }

        {newUI &&
          <div className="dashboard__row" id="dashboard__rowUIMigration">
            <div className="dashboard__trialNotice">
              <span>We have a new UI for PluginSEO. Try it out <strong><a href={API_BASE + UI_MIGRATION_PATH}>here</a></strong>.</span>
              <button className="dashboard__trialClose close"
                onTouchTap={() => this.hideUIMigration()}>
                <span className="sr-only">Close</span>
              </button>
            </div>
          </div>
        }

        <div className="dashboard__column">
          <Checks checks={this.props.checks} notFoundLinks={this.props.links} />
        </div>
        <div className="dashboard__column wide">
          <SimpleCard
            title={searchTrendsTitle}
            info={true}
            link="https://support.pluginuseful.com/hc/en-us/articles/23534811246484-What-metrics-are-tracked-in-my-SEO-trends"
            className="dashboard__searchTrends"
          >
            <SearchConsoleContainer compact />
          </SimpleCard>
          <SeoToolsContainer placeholder={!activeCharge} />
          <RecommendedJobs checks={this.props.checks} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/containers/ChecksContainer.js